<template>
  <div class="app-list-wrap app-list-wrap-fake">
    <div class="app-list-item" v-for="(item, index) in applicationsFake" :key="item.id">
      <div class="app-top">
        <div class="app-top-head app-top-head-fake">
          <div>
            <div></div>{{item.app_name}}
          </div>
          <div>
            <i class="iconfont icon-update hover-icon"></i>
            <i class="iconfont icon-android hover-icon"></i>
            <i class="iconfont icon-delete hover-icon"></i>
          </div>
        </div>
        <div class="app-top-body">
          <div class="body-desc1">
            <img src="../assets/img/app-icon-fake.png" class="body-logo"/>
            <div class="body-desc1-rignt">
              <p class="multline">{{item.app_name}}</p>
              <div>
                <i class="iconfont icon-update hover-icon"></i>
                <i class="iconfont icon-android hover-icon"></i>
                <i class="iconfont icon-delete hover-icon"></i>
              </div>
            </div>
          </div>
          <div class="body-desc">
            <div class="body-desc-left">
              <div>
                <span>{{$t('messages.home.tip27')}}</span>
                <span>{{item.publisher}}</span>
              </div>
              <div>
                <span>{{$t('messages.home.tip28')}}</span>
                <span>{{item.category}}</span>
              </div>
              <div>
                <span>{{$t('messages.home.tip52')}}</span>
                <div>
                  <img src="../assets/img/ID-icon.png" width="48"/>
                  <span>ID-Indonesia</span>
                </div>
              </div>
            </div>
            <div class="body-desc-right">
              <div>
                <span>{{$t('messages.home.tip29')}}</span>
                <span>{{item.install_times}}</span>
              </div>
              <div>
                <span>{{$t('messages.home.tip30')}}</span>
                <span>{{item.reviews}}</span>
              </div>
              <div>
                <span>{{$t('messages.home.tip31')}}</span>
                <div>
                  <el-rate
                    v-model="item.ratings"
                    disabled
                    show-score
                    text-color="#ff9900"
                    score-template="{value}"
                    :max="Number(5.0)"
                    >
                  </el-rate>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="app-tabs">
        <div :class="{'tab-item':true,'tab-item-fake':true,'tab-item-active':index2===activeIndex}" v-for="(item2, index2) in tabs" :key="index2">
          <i :class="item2.icon"></i>
          <span>{{item2.title}}</span>
          <template v-if="index2===2">
            <span>:</span>
            <span style="color: #1861F2;margin-left: 4px;">{{item.running_campaigns}}</span>
          </template>
          <span v-if="index2===1" class="static-tab">{{$t('messages.guide.guide10')}}</span>
        </div>
      </div>
      <div class="app-bot" v-if="store.state.introStepInfo.currentStep===4">
        <div class="app-bot-list">
          <div class="app-bot-item-fake" v-for="(item2, index2) in plans" :key="index2">
            <div class="app-bot-item-top">
              <div :class="`dismantle${index2} el-progress`">
                <el-progress :stroke-width="16" type="circle" :format="(per)=>getTip(per,index2)" :percentage="getPercent(index2)" class="tab1"></el-progress>
                <progress-color style="width: 0;height: 0;"></progress-color>
              </div>
              <div class="item-p-wrap">
                <p class="item-p">
                  <span :class="`itemSpan${index2}`"></span>
                  <span>Achieved: {{getAchieved(index2)}}</span>
                </p>
                <p class="item-p2">
                  <span></span>
                  <span>{{getSubTip(index2)}}</span> 
                  <i class="iconfont icon-a-Union2" style="color: #D0D3D9;"></i>
                </p>
              </div>
            </div>
            <div style="text-align: center;">
              <div :class="`item-btn btn-${index2} item-btn-fake`">{{$t(`messages.other.${btnText[index2]}`)}}</div>
              <img src="../assets/img/fake-click.png" width="30" style="margin-top: 4px;"/>
            </div>
          </div>
        </div>
        <div class="item-tips-fake" style="text-align: center;">
          <p>{{ $t('messages.home.tip69') }}</p>
          <p style="margin-bottom: 8px">{{ $t('messages.home.tip22') }}</p>
          <p>{{ $t('messages.home.tip59') }} <span >{{ $t('messages.home.tip23') }}</span> {{ $t('messages.home.tip60') }}.</p>
        </div>
      </div>
      <div class="app-bot-static" v-if="store.state.introStepInfo.currentStep===6">
        <div class="ym-board">
          <div class="board-data">
            <div
              class="detail-data"
              :key="index"
              v-for="(data, index) in head_data"
              :style="{
                borderLeftColor: data.color,
                borderLeftWidth: '4px',
                borderLeftStyle: 'solid',
              }"
            >
              <div class="detail-label">{{ data.name }}</div>
              <div class="detail-val">
                {{formatData(item[data.key], ',')}}
              </div>
            </div>
        </div>
        <div id="chart_fake" class="chart_css"></div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import progressColor from '../components/progressColor.vue';
import store from '../vuex/store'
export default {
  name: 'appItemFake',
  components: {
    progressColor,
  },
  data(){
    return {
      store,
      applicationsFake:[
        {
          app_name: 'Bunpo: Learn Japanese',
          app_store_url: 'https://play.google.com/store/apps/details?id=com.bunpoapp&gl=hk&hl=en',
          category: 'Shopping',
          country: 'HK',
          icon_url: 'https://play-lh.googleusercontent.com/3MoeRV5Ri0lJsVe7bxWr9ksdLQEP9N9Ye3he5sOSTHJMcGvGh5-HDMNGYsyZ_QijuQ',
          id: 1785,
          installOver: false,
          install_times: '100000000',
          package: 'com.bunpoapp',
          publisher: 'ASOGrow',
          rateOver: false,
          ratings: 4.74,
          reviewOver: false,
          reviews: '18493215',
          running_campaigns: 4,
        }
      ],
      histories:[
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 10,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-01',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 55,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-02',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 105,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-03',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 135,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-04',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 175,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-05',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 250,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-06',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 350,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-07',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 450,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-08',
        },
        {
          reviews: 59,
          ratings: 4.8,
          install_times: 550,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-09',
        },
        {
          reviews: 60,
          ratings: 4.8,
          install_times: 650,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-10',
        },
        {
          reviews: 60,
          ratings: 4.8,
          install_times: 750,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-11',
        },
        {
          reviews: 60,
          ratings: 4.8,
          install_times: 850,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-12',
        },
        {
          reviews: 60,
          ratings: 4.8,
          install_times: 1000,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-13',
        },
        {
          reviews: 60,
          ratings: 4.8,
          install_times: 1000,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-14',
        },
        {
          reviews: 60,
          ratings: 4.8,
          install_times: 1000,
          record_type: 'Campaign(583) Promotion Period',
          dt: '06-15',
        },
      ],
      activeIndex:0,
    }
  },
  props: {
    head_data: {
      type: Array,
      default() {
        return []
      },
    },
    btnText: {
      type: Array,
      default() {
        return []
      },
    },
    plans: {
      type: Array,
      default() {
        return []
      },
    },
    tabs: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    getTip(percentage,index){
      // let arr = ['Installs','Reviews','Ratings']
      let arr = ['tip29','tip30','tip31']
      let str = percentage + '%' + '\n' + this.$t(`messages.home.${arr[index]}`)
      return str
    },
    getPercent(index2){
      let arr = [30,30,60]
      return arr[index2]
    },
    getAchieved(index2){
      let arr = [3000,300,3.2]
      return arr[index2]
    },
    getSubTip(index2){
      let arr = ['Goal:20000','Goal:20000','Goal:4.8']
      return arr[index2]
    },
  },
  watch: {
    '$store.state.introStepInfo.currentStep': {
      handler(newVal,oldVal) {
        if(parseInt(sessionStorage.getItem('complete_guide'))) return;
        if(newVal === 6){
          this.$nextTick(()=>{
            this.$emit('setChartData',this.histories,'fake')
          })
          this.activeIndex = 1
        }else if(newVal === 4){
          this.activeIndex = 0
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.dismantle0 /deep/ .el-progress-circle,.dismantle1 /deep/ .el-progress-circle,.dismantle2 /deep/ .el-progress-circle{
  svg > path:nth-child(1) {
     stroke: #F0F3FA;
   }
}
.dismantle0 /deep/ .el-progress-circle {
   // 进度条颜色
   svg > path:nth-child(2) {
     stroke: url(#dismantle0);  // 该url() 中填入的是, 对应组件中的 id 名
   }
 }
 .dismantle1 /deep/ .el-progress-circle {
   // 进度条颜色
   svg > path:nth-child(2) {
     stroke: url(#dismantle1);  // 该url() 中填入的是, 对应组件中的 id 名
   }
 }
 .dismantle2 /deep/ .el-progress-circle {
   // 进度条颜色
   svg > path:nth-child(2) {
     stroke: url(#dismantle2);  // 该url() 中填入的是, 对应组件中的 id 名
   }
 }

</style>

<style lang="scss">
.app-list-wrap-fake{
  .item-btn-fake{
    cursor: inherit !important;
  }
  .tab-item-fake{
    cursor: inherit !important;
    &:hover{
      background: #fff !important;
      >span{
        color: #303133 !important;
      }
      >i{
        color: #D0D3D9 !important;
      }
    }
  }
  .app-top-head-fake{
    .hover-icon{
      cursor: inherit !important;
      &:hover{
        color: #D0D3D9 !important;
      }
    }
  }
}
</style>